import { render, staticRenderFns } from "./ComplainItem.vue?vue&type=template&id=40e26624&scoped=true"
import script from "./ComplainItem.vue?vue&type=script&lang=js"
export * from "./ComplainItem.vue?vue&type=script&lang=js"
import style0 from "./ComplainItem.vue?vue&type=style&index=0&id=40e26624&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e26624",
  null
  
)

export default component.exports